<template lang="pug">
  video(
    :poster="poster"
    ref="videojs"
    class="video-js"
    muted
    controls
    preload="auto"
    autoplay
  )
    source(:src="stream" type="application/x-mpegURL")
</template>

<script>
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'

export default {
  props: ['poster', 'stream'],

  methods: {
    initStream() {
      if (this.player) {
        this.player.dispose()
      }
      if (this.$refs.videojs) {
        this.player = Videojs(this.$refs.videojs, { fluid: true })
      }
    }
  },

  mounted() {
    if (this.stream) {
      this.initStream()
    }
  },

  destroyed() {
    if (this.player) {
      this.player.dispose()
      this.player = null
    }
  },

  watch: {
    stream(val) {
      if (val) {
        this.initStream()
      }
    }
  }
}
</script>

<style scoped></style>
